<ng-template #emptyState>
    <!--<div class="ig-panelbox__content">-->

      <!-- No content after search/filter -->
      <ng-container *ngIf="!!search || filterFavorites || customFilterEnabled">
        <ig-empty-state
          [imageSrc]="emptyImageSrc"
          [message]="(filterFavorites && !search ? 'TABLE_GEN_3.FILTER.EMPTY_FAV' : 'TABLE_GEN_3.FILTER.EMPTY') | uitranslate : {searchables: itemPlural}"
          [messageHeadline]="(filterFavorites && !search ? 'TABLE_GEN_3.FILTER.EMPTY_HEADLINE_FAV' : 'TABLE_GEN_3.FILTER.EMPTY_HEADLINE') | uitranslate : {searchables: itemPlural}"
          [readOnly]="false">
        </ig-empty-state>
      </ng-container>


      <!-- No content in the DB -->
      <ng-container *ngIf="!filterFavorites && !search && emptyPlaceholder && !customFilterEnabled">
        <!-- No <<Create/add new>> button -->
        <ig-empty-state
          *ngIf="!createBtn"
          [imageSrc]="emptyImageSrc"
          [message]="emptyPlaceholder"
          [messageHeadline]="emptyPlaceholderHeadline"
          [messageReadOnly]="emptyPlaceholderReadOnly"
          [messageHeadlineReadOnly]="emptyPlaceholderHeadlineReadOnly"
          [readOnly]="readOnly">
        </ig-empty-state>

        <!-- With <<Create/add new>> button -->
        <ig-empty-state
          *ngIf="createBtn"
          [imageSrc]="emptyImageSrc"
          [message]="emptyPlaceholder"
          [messageHeadline]="emptyPlaceholderHeadline"
          [messageReadOnly]="emptyPlaceholderReadOnly"
          [messageHeadlineReadOnly]="emptyPlaceholderHeadlineReadOnly"
          [createBtnLabel]="createBtn.label"
          createBtn="createBtn"
          (createBtnClicked)="createBtn.func()"
          [readOnly]="readOnly">
        </ig-empty-state>
      </ng-container>

    <!--</div>-->
  </ng-template>


  <div class="ig-data-table-wrapper" [ngClass]="tableStyleClass" #igDataTableWrapperLevel0>

    <div [ngClass]="{'ig-panelbox__inner': !tableStyleConfig.frameless}" *ngIf="tableTitle || (!hideFilter && (total !== 0 || search || toggleFavoritesEnabled || customFilterEnabled)) || (createBtn && createBtnInHeader && (total !== 0 || !emptyPlaceholder))">
      <!-- Table header area -->
      <div class="ig-data-table-wrapper__header" [ngClass]="{'p-mb-3': tableStyleConfig.frameless || (tableStyleConfig.tableHeight && tableStyleConfig.tableHeight !== 'auto' && hideFilter), 'p-mb-5': tableStyleConfig.tableHeight && tableStyleConfig.tableHeight !== 'auto' && !hideFilter}">

        <div class="ig-data-table-wrapper__header-content" *ngIf="tableTitle || (!hideFilter && (total !== 0 || search || toggleFavoritesEnabled || customFilterEnabled))">

          <!-- Table title -->
          <div class="ig-data-table-wrapper__header-title" *ngIf="tableTitle" [ngClass]="{'p-mb-2': tableStyleConfig.tableHeight && tableStyleConfig.tableHeight !== 'auto', 'p-mb-4': ( !hideFilter && (total !== 0 || search || toggleFavoritesEnabled) )}">
            <h3>
              {{ tableTitle }}
              <ig-count-label *ngIf="showTotalCount" [label]="total.toString()"></ig-count-label>
            </h3>
          </div>

          <!-- Search/filter -->
          <div *ngIf="!hideFilter && (total !== 0 || search || toggleFavoritesEnabled || customFilterEnabled)" class="ig-data-table-wrapper__filter-container">

            <!-- Filter input -->
            <div class="ig-data-table-wrapper__filter-input p-d-flex p-ai-center">
              <div class="ig-data-table-wrapper__filter-input-field">

                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input
                    type="text"
                    pInputText
                    [placeholder]="(filterPlaceholder ? filterPlaceholder : 'TABLE_GEN_3.FILTER.PLACEHOLDER') | uitranslate"
                    [(ngModel)]="search"
                    (ngModelChange)="onSearch()"
                    maxlength="64"
                  />
                </span>

                <button class="ig-data-table-wrapper__filter-reset" (click)="resetSearch()" *ngIf="search">
                  <i class="pi pi-times"></i>
                </button>
              </div>

            </div>

            <!-- Show only favorites -->
            <div class="ig-data-table-wrapper__filter-favorites" *ngIf="showFavorite && showMakeFavAction === true">
              <p-checkbox
                [label]="'TABLE_GEN_3.FAVORITES.LABEL' | uitranslate"
                inputId="tabletofflefavoritedcb"
                [(ngModel)]="toggleFavoritesEnabled"
                (onChange)="onToggleFavorites()"
                [binary]="true"
              ></p-checkbox>
            </div>

            <!-- Placeholder for custom filter stuff -->
            <div class="ig-data-table-wrapper__filter-after">
              <ng-content select="#afterFilter"></ng-content>
            </div>

          </div>

        </div>

        <!-- Table create button -->
        <div class="ig-data-table-wrapper__header-button" *ngIf="createBtnInHeader && createBtn && (total !== 0 || !emptyPlaceholder)">
          <ig-button
            [disabled]="readOnly"
            e2e="btn-table-create"
            [mode]="createBtn.secondary ? 'secondary' : ''"
            [label]="createBtn.label"
            (onClick)="createBtn.func()"
            [icon]="createBtn.icon || ''"
            class="create-button"
            gsUserRole
          ></ig-button>
        </div>
      </div>
    </div>


    <div
      class="ig-data-table-wrapper__data-container"

      [class.ig-data-table-wrapper__data-container--fixed-height]="tableStyleConfig.tableHeight && tableStyleConfig.tableHeight !== 'auto' && !tableStyleConfig.fluidTableHeight"
      [class.ig-data-table-wrapper__data-container--fixed-height-max]="tableStyleConfig.tableHeight && tableStyleConfig.tableHeight !== 'auto' && tableStyleConfig.fluidTableHeight"
      [class.ig-data-table-wrapper__data-container--is-loading]="loading"
    >

        <!-- No content -->
        <div class="ig-panelbox__inner ig-panelbox__inner--no-bg ig-data-table-wrapper__no-content" *ngIf="!loading && total === 0">
          <ng-container [ngTemplateOutlet]="emptyState"></ng-container>
        </div>

        <div class="ig-data-table-wrapper__loading" *ngIf="loading && hideEmptyTable">
          <ig-loader size="parentSize"></ig-loader>
        </div>

      <!-- The table -->
      <internal-table
        *ngIf="!hideEmptyTable || !!data?.length"

        [tableStyleConfig]="tableStyleConfig"

        [hasHelperCell]="hasHelperCell"
        [jsHoverDisabled]="jsHoverDisabled"

        [columns]="columns"
        [data]="data || []"
        [userColumns]="userColumns"
        [total]="total"
        [dataPrimaryKey]="dataPrimaryKey"

        [search]="search"
        [searchBy]="searchBy"

        [busyRows]="busyRows"

        [selection]="selection"
        [disabledSelection]="disabledSelection"
        [selectedActions]="selectedActions"
        [selectable]="selectable"
        [multiSelect]="multiSelect"
        [allSelect]="allSelect"

        [sort]="sort"
        [sortDirection]="sortDirection"
        [showFavorite]="showFavorite"

        [viewportElement]="viewportElement"
        [fixedHeaderOffset]="fixedHeaderOffset"
        [disableContextMenu]="disableContextMenu"

        [fixedHeader]="fixedHeader"
        [fixedFirstColumn]="fixedFirstColumn"
        [fixedLastColumn]="fixedLastColumn"

        [showMakeFavAction]="showMakeFavAction"

        [loading]="loading"
        [loadingNext]="loadingNext"
        (loadNext)="onLoadNext()"

        (cellClick)="cellClick.emit($event)"
        (changeColumns)="changeColumns.emit($event)"
        (changeSort)="changeSort.emit($event)"
        (selectionChange)="onSelectionChange($event)"
        (storeFavorites)="storeFavorites.emit($event)"
        (storeUnFavorites)="storeUnFavorites.emit($event)">
      </internal-table>
    </div>
  </div>
